import { CMS_REGISTRATION } from "../../store/data/actionTypes"
import store from "../../store"

// 사용 안함!!!!!!!!!!!!!!!!!
export const setCmsRegistrationModal = (isOpen = true) => {
  store.dispatch({
    type: CMS_REGISTRATION,
    payload: isOpen
  })
}


export const CMS_REGISTRATION_FORM_URL = 'https://smileceo-files.s3.ap-northeast-2.amazonaws.com/cms/%5B%EC%98%81%EC%9A%B0%EC%A0%95%EB%B3%B4%EC%84%9C%EB%B9%84%EC%8A%A4%5D+NICE%ED%8E%98%EC%9D%B4%EB%A8%BC%EC%B8%A0+CMS%EC%8B%A0%EC%B2%AD%EC%84%9C_241001.zip'

export default setCmsRegistrationModal